import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { AiActivityTestIds } from '../../AiActivity.testIds';
import { groupStepsByWave, resolveBlockedStepIds } from '../../AiActivity.utils';

import {
  parallelCaptionStyles,
  parallelGroupStyles,
  railStyles,
  railTitleStyles,
} from './StepNavRail.styles';
import StepNavRow from './StepNavRow';

const StepNavRail = ({ steps, selectedStepId, onSelect }) => {
  const blockerByStepId = useMemo(() => resolveBlockedStepIds(steps), [steps]);
  const waveGroups = useMemo(() => groupStepsByWave(steps), [steps]);

  return (
    <Box data-testid={AiActivityTestIds.STEP_NAV_RAIL} sx={railStyles}>
      <Typography sx={railTitleStyles} variant="bold12">
        Steps
      </Typography>
      {waveGroups.map((group, groupIndex) => {
        const isParallel = group.steps.length > 1;
        const isLastGroup = groupIndex === waveGroups.length - 1;
        const rows = group.steps.map(step => (
          <StepNavRow
            blockedBy={blockerByStepId.get(step.id)}
            hasConnector={!isParallel && !isLastGroup}
            isSelected={step.id === selectedStepId}
            key={step.id}
            number={step.stepNumber ?? steps.indexOf(step) + 1}
            step={step}
            onSelect={onSelect}
          />
        ));

        if (!isParallel) {
          return rows;
        }

        return (
          <Box
            data-testid={AiActivityTestIds.STEP_NAV_PARALLEL_GROUP}
            key={`wave-${group.wave}`}
            sx={parallelGroupStyles}
          >
            <Typography sx={parallelCaptionStyles} variant="medium12">
              Runs in parallel · {group.steps.length} steps
            </Typography>
            {rows}
          </Box>
        );
      })}
    </Box>
  );
};

StepNavRail.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedStepId: PropTypes.string,
};

export default memo(StepNavRail);
